import { Box } from "@mui/material";
import { useInView } from "framer-motion";
import { useRef, useState } from "react";
import { gcsUriToHttps } from "src/utils/gcs";
import { DEFAULT_VIDEO_ASPECT_RATIO } from "components/scrapEyeDataDashboard/VideoPlayer/constants";

type Props = Readonly<{
  mp4Path: string | null | undefined;
  label: string;
}>;

export const DeviceVideoPreview = ({ mp4Path, label }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isVisible = useInView(containerRef, { once: true });
  const [failedVideoPath, setFailedVideoPath] = useState<string | null>(null);
  const videoPath = mp4Path && mp4Path !== failedVideoPath ? mp4Path : null;

  return (
    <Box
      ref={containerRef}
      sx={{
        width: 400,
        maxWidth: "100%",
        aspectRatio: DEFAULT_VIDEO_ASPECT_RATIO,
        borderRadius: 2,
        overflow: "hidden",
        backgroundColor: "grey.100",
        "& video": {
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: "contain",
        },
      }}
    >
      {isVisible && videoPath && (
        <video
          key={videoPath}
          src={gcsUriToHttps(videoPath)}
          aria-label={label}
          muted
          playsInline
          preload="metadata"
          onLoadedMetadata={({ currentTarget }) => {
            if (
              Number.isFinite(currentTarget.duration) &&
              currentTarget.duration > 0
            ) {
              currentTarget.currentTime = Math.min(
                0.001,
                currentTarget.duration / 2
              );
            }
          }}
          onError={() => {
            setFailedVideoPath(videoPath);
          }}
        />
      )}
    </Box>
  );
};
